import { render, staticRenderFns } from "./UploadImageError.vue?vue&type=template&id=ced4bf8e&"
import script from "./UploadImageError.vue?vue&type=script&lang=js&"
export * from "./UploadImageError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports